<template name="deviceTotalVariable">
	<div>
      <!-- 搜索部分 -->
      <div style="display: flex;justify-content: center;">
        <el-input style="width: 60%;margin-right: 10px"
                  placeholder="输入变量名称搜索"
                  v-model="searchTitle"
                  clearable>
        </el-input>
        <el-button icon="el-icon-search" circle @click="getDeviceList"></el-button>
      </div>

			<div style="margin-top: 10px;">
				<el-table :data="deviceList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
					:header-cell-style="{ background: '#F2F2F2', color: '#333' }">
					<el-table-column prop="id" label="id" width="137" show-overflow-tooltip align="center"/>
					<el-table-column prop="deviceName" label="设备名称"  show-overflow-tooltip align="center"/>
					<el-table-column prop="sn" label="设备序列号"  show-overflow-tooltip  align="center"/>
					<el-table-column label="详情" width="200" align="center" >
						<template v-slot="scope" >
							<el-button @click="pick(scope.row)" type="primary" size="small">变量详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
</template>

<script>
  import API from "@/../config/api.js";
	export default {
		name: "deviceTotalVariable",
		data() {
			return {
        deviceList: [],
				userId: '',
				customStyle: {
					color: '#3399ff',
				},
				customStyle3:{
					color: '#55aa00',
				},
				customStyle4: {
					color: '#aa55ff',
				},
				tempDeviceId: 0,
				searchTitle:'',       //搜索的项目名称
			}
		},
		//此处定义传入的数据
		props: {
			companyId: Number,
		},
		mounted: function() {
			this.userId = window.localStorage.getItem('userid');
			console.log('公司一级项目管理userId的值=', this.userId);
			console.log(this.companyId)
			// 获取该公司全部的一级项目
			this.deviceList = []
			this.getDeviceList();
		},
		methods: {
			// 获取当前公司所有的设备，已经调通
			getDeviceList() {
				let header = {
					"Content-Type": "application/x-www-form-urlencoded"
				}
	
				let data = {
					companyId: this.companyId,
					deviceName:this.searchTitle,
					device_type: 1,
				}
				console.log(data)
				this.$axiosRequest({
					url: API.getDeviceList,
					method: 'POST',
					data: data,
					header: header,
					success: res => {
						console.log(res.data)
						this.deviceList = res.data["deviceList"]
		
					}
				});
			},
			//清空搜索
			clear(){
				this.searchTitle='';
				this.getDeviceList();
			},
			pick(item){
				this.$emit('autopick',item)
			}
		},
	}
</script>

<style>
	.button-group-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
	}
	
	.row-line {
		line-height: 20px;
	}
	
	.info-title {
		font-size: 18px;
		font-weight: bold;
		color: #004768;
		font-family: '仿宋';
	}
	
	.info-content {
		font-size: 18px;
		font-family: '仿宋';
		font-weight: bold;
	}
	
	.button-group-title {
		font-size: 18px;
		font-weight: bold;
	}
	
	.info-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
		background-color: rgba(240, 240, 240, 0.7);
	}
	
	.info-content {
		margin: 10px 0px 10px 10px;
		height: auto;
	}
	
	.title-style {
		font-size: 18px;
		font-weight: bold;
	}
	
	.title2-style {
		font-size: 15px;
		line-height: 40px;
	}
	
	.title3-style {
		font-size: 14px;
		line-height: 40px;
	}
	
	.btn {
		margin-left: 80px;
	
	}

	.user-info-content {
		font-weight: bold;
	}
	
	.info-content {
		margin: 10px 0px 10px 10px;
		height: auto;
	}
	
	.title-style {
		font-size: 18px;
		font-weight: bold;
	}
	
	.title2-style {
		font-size: 15px;
		font-weight: bold;
		line-height: 40px;
	}
	
	.button-group-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
	}
</style>